import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';
import qs from 'query-string';

import FullScreenLoader from '../../../../../../components/global/FullScreenLoader';
import VideoSlideshowGridViewer from '../../../../../../components/grid/components/VideoSlideshowGridViewer';
import useBasename from '../../../../../../components/routing/useBasename';
import { DISPLAY_MODE } from '../../../../../../components/grid/components/VideoSlideshowGridViewer/VideoSlideshowGridViewer';
import useVideoSlideshow from '../hooks/useVideoSlideshow';
import {
  isNativeAppWebView,
  postNativeAppAlbumSlideshowViewerDismiss,
} from '../../../../../../services/native-bridge/native-apps-interface';
import { VIDEO_TYPE } from '../../../../../../constants/videos';
import { isVGBContext } from '../../../../../../util/album';

const propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      slideId: PropTypes.string,
    }),
  }),
  slideshow: PropTypes.shape({
    photos: PropTypes.shape({
      total: PropTypes.number,
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
        }),
      ),
    }),
    layouts: PropTypes.shape({
      total: PropTypes.number,
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
        }),
      ),
    }),
    slide_duration_ms: PropTypes.number,
  }),
};

const AlbumSlideshowView = ({ history, location, match }) => {
  const basename = useBasename();
  const [displayMode, setDisplayMode] = useState(DISPLAY_MODE.PREVIEW);
  const isNativeView = isNativeAppWebView();
  const queryParams = qs.parse(location.search);
  const { albumId, slideId } = match.params;

  const { album, videos, slideshow, loading, loadingMore, onLoadMore } =
    useVideoSlideshow({
      albumId,
    });

  useEffect(() => {
    if (queryParams?.present === '1') {
      setDisplayMode(DISPLAY_MODE.PRESENT);
    }
  }, []);

  if (!slideshow || !album) {
    return <FullScreenLoader />;
  }

  const hasGreetingVideo = !!videos.records.find(
    slideshowVideo =>
      slideshowVideo.display_order === -1 ||
      slideshowVideo.video.type === VIDEO_TYPE.GREETING,
  );

  if (!slideId && !hasGreetingVideo && isVGBContext(album)) {
    history.replace(
      `${location.pathname}/s/${slideshow.default_greeting_video.id}?present=${
        queryParams?.present ?? 0
      }`,
    );
  } else if (!slideId && videos.total > 0) {
    history.replace(
      `${location.pathname}/s/${videos.records[0].video.id}?present=${
        queryParams?.present ?? 0
      }`,
    );
  }

  return (
    <Fragment>
      <VideoSlideshowGridViewer
        album={album}
        loading={loading}
        recordId={slideId}
        records={
          hasGreetingVideo || !isVGBContext(album)
            ? videos.records
            : [{ video: slideshow.default_greeting_video }, ...videos.records]
        }
        recordsTotal={videos.total}
        loadMore={onLoadMore}
        loadingMore={loadingMore}
        includeWaldoLogo={false}
        shouldLoadMore={videos.total > videos.records.length}
        gridPath={`/app/${basename}/albums/${albumId}/photos`}
        videosLayout={slideshow.videos_layout}
        displayMode={displayMode}
        dismissible={displayMode !== DISPLAY_MODE.PRESENT || isNativeView}
        onDismiss={() => {
          if (isNativeView) {
            postNativeAppAlbumSlideshowViewerDismiss();
          } else {
            history.goBack();
          }
        }}
        renderTitle={() => {
          if (isNativeView) {
            return '';
          }
          return (
            <Fragment>
              <h3 className="w-100 text-white text-center mb-0 d-none d-md-block">
                {album?.name}
              </h3>
              <h5 className="w-100 text-white text-center mb-0 d-md-none">
                {album?.name}
              </h5>
            </Fragment>
          );
        }}
      />
    </Fragment>
  );
};

AlbumSlideshowView.propTypes = propTypes;

export default compose(withRouter)(AlbumSlideshowView);
